import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import Upload from "./pages/Upload";
import Reports from "./pages/Reports";
import ReportDetail from "./pages/ReportDetail";
import Configure from "./pages/Configure";
import CreateProject from "./pages/CreateProject";
import SanityCheck from "./pages/SanityCheck";
import Review from "./pages/Review";
import Processing from "./pages/Processing";
import UserManagement from "./pages/UserManagement";
import Settings from "./pages/Settings";
import Comparison from "./pages/Comparison";
import SelectProject from "./pages/SelectProject";
import ProjectDashboard from "./pages/ProjectDashboard";
import ProjectSettings from "./pages/ProjectSettings";
import ProjectGuard from "./components/ProjectGuard";
import ProjectMembersView from "./components/ProjectMembersView";

const Guard = ({ children }: { children: React.ReactNode }) => {
  return localStorage.getItem("token") ? <>{children}</> : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Guard><Dashboard /></Guard>} />
        <Route path="/projects" element={<Guard><Projects /></Guard>} />
        <Route path="/upload/:projectId" element={<Guard><ProjectGuard><Upload /></ProjectGuard></Guard>} />
        <Route path="/reports" element={<Guard><Reports /></Guard>} />
        <Route path="/select-project" element={<Guard><SelectProject /></Guard>} />
        <Route path="/create-project" element={<Guard><CreateProject /></Guard>} />
        <Route path="/dashboard/:projectId" element={<Guard><ProjectGuard><ProjectDashboard /></ProjectGuard></Guard>} />
        <Route path="/compare" element={<Guard><Comparison /></Guard>} />
        <Route path="/settings" element={<Guard><Settings /></Guard>} />
        <Route path="/users" element={<Guard><UserManagement /></Guard>} />
        <Route path="/projects/:projectId/members" element={<Guard><ProjectGuard><ProjectMembersView /></ProjectGuard></Guard>} />
        <Route path="/settings/project/:projectId" element={<Guard><ProjectGuard><ProjectSettings /></ProjectGuard></Guard>} />
        <Route path="/processing/:projectId" element={<Guard><ProjectGuard><Processing /></ProjectGuard></Guard>} />
        <Route path="/review/:projectId" element={<Guard><ProjectGuard><Review /></ProjectGuard></Guard>} />
        <Route path="/sanity/:projectId" element={<Guard><ProjectGuard><SanityCheck /></ProjectGuard></Guard>} />
        <Route path="/configure/:projectId" element={<Guard><ProjectGuard><Configure /></ProjectGuard></Guard>} />
        <Route path="/reports/:reportId" element={<Guard><ReportDetail /></Guard>} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
